import { Component, OnInit, HostBinding, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

import { EventBusService } from '../../services/event-bus.service';

import { CrossBrowsing } from '../../constants/cross-browsing';

const ZOOM_STEP = 25;
const MAX_ZOOM = 300;
const MIN_ZOOM = 100;

@Component({
  selector: 'viewer-fixedlayout-page-control',
  templateUrl: './fixedlayout-page-control.component.html',
  styleUrls: ['./fixedlayout-page-control.component.scss'],
})
export class FixedlayoutPageControlComponent implements OnInit, OnDestroy {
  private _unsubscriber = new Subject<void>();

  @HostBinding('class.disabled') disabled = false;
  @HostBinding('class.hidden') hidden = true;

  public currentScale = 100;
  private zoomKeep = false;

  constructor(private eventBusService: EventBusService) {}

  ngOnInit(): void {
    if (CrossBrowsing.supportsPinchZoom) {
      this.disabled = true;
    } else {
      this.eventBusService
        .on('ContentsComponent:bookLoad')
        .pipe(takeUntil(this._unsubscriber))
        .subscribe(() => {
          this.disabled = true;
        });

      this.eventBusService
        .on('ContentsComponent:itemLoad')
        .pipe(takeUntil(this._unsubscriber))
        .subscribe(({ items }) => {
          this.disabled = items.some((item) => item.layout !== 'fixed');

          if (!this.zoomKeep) {
            this.currentScale = 100;
            this.resetZoomButtonClick();
          }
        });

      this.eventBusService
        .on('SidebarContainerComponent:opened')
        .pipe(
          takeUntil(this._unsubscriber),
          filter(({ position }) => position === 'bottom')
        )
        .subscribe(() => {
          this.hidden = false;
        });

      this.eventBusService
        .on('SidebarContainerComponent:closed')
        .pipe(
          takeUntil(this._unsubscriber),
          filter(({ position }) => position === 'bottom')
        )
        .subscribe(() => {
          this.hidden = true;
        });
    }

    this.eventBusService
      .on('ContentsComponent:settingsChanged')
      .pipe(takeUntil(this._unsubscriber))
      .subscribe(({ settings }) => {
        this.zoomKeep = settings.zoomKeep.value;
      });

    this.eventBusService
      .on('FixedLayoutPageControlComponent:changeZoom')
      .pipe(takeUntil(this._unsubscriber))
      .subscribe(({ scale }) => {
        this.currentScale = scale;
      });
  }

  ngOnDestroy(): void {
    this._unsubscriber.next();
    this._unsubscriber.complete();
  }

  zoomButtonClick(value: 1 | -1): void {
    let newScale = this.currentScale + value * ZOOM_STEP;

    if (newScale > MAX_ZOOM) {
      newScale = MAX_ZOOM;
    } else if (newScale < MIN_ZOOM) {
      newScale = MIN_ZOOM;
    }

    this.eventBusService.fire('FixedLayoutPageControlComponent:changeZoom', {
      scale: newScale,
    });
  }

  resetZoomButtonClick(): void {
    this.eventBusService.fire('FixedLayoutPageControlComponent:changeZoom', {
      scale: 100,
    });
  }
}
